import { axios } from "../helpers/axios";
import { setNoAlertStatus } from "../helpers/storage";

// api to fetch on initial annotation load
/**
 * Fetches an image for annotation based on the provided part ID, image ID, and bucket type.
 * @param part_id - The ID of the part.
 * @param image_id - The ID of the image.
 * @param bucket - The type of bucket where the image is stored.
 * @returns A promise that resolves with the image data.
 */
export const fetchImage = (
  part_id: string,
  image_id: string,
  bucket: string
): Promise<any> => {
  return axios.get(
    `annotate/get_img/?part_id=${part_id}&file_id=${image_id}&bucket_type=${bucket}`
  );
};

/**
 * Submits annotations to the server.
 * @param payload - The annotation data to be submitted.
 * @returns A promise that resolves with the response of the API call.
 */
export const submitAnnotation = (payload: any): Promise<any> => {
  return axios.post(`annotate/submit_annotations/`, payload);
};

/**
 * Fetches the next image for annotation based on the provided part ID, image ID, and bucket type.
 * @param part_id - The ID of the part.
 * @param image_id - The ID of the current image.
 * @param bucket - The type of bucket where the image is stored.
 * @returns A promise that resolves with the next image data.
 */
// API for fetching next
export const getNextImage = (
  part_id: string,
  image_id: string,
  bucket: string
): Promise<any> => {
  return axios.get(
    `annotate/next_img/?part_id=${part_id}&file_id=${image_id}&bucket_type=${bucket}`
  );
};

/**
 * Fetches the previous image for annotation based on the provided part ID, image ID, and bucket type.
 * @param part_id - The ID of the part.
 * @param image_id - The ID of the current image.
 * @param bucket - The type of bucket where the image is stored.
 * @returns A promise that resolves with the previous image data.
 */
// API for fetching previous
export const getPrevImage = (
  part_id: string,
  image_id: string,
  bucket: string
): Promise<any> => {
  return axios.get(
    `annotate/prev_img/?part_id=${part_id}&file_id=${image_id}&bucket_type=${bucket}`
  );
};
